var exports = {
  "k": "x43aef4ae--8f7e1d--container",
  "N": "x43aef4ae--8f7e1d--card",
};

module.exports = exports;
